<template>
  <div class="service-support-detail-wrap">
    <DetailPageWrap
      :titleCardOptions="titleCardOptions"
      :description="resultDetails"
      @switchTitle="handleChange"
    >
      <template>
        <div class="card-wrap">
          <a-row :gutter="[8, 0]" type="flex">
            <a-col :span="18">
              <div class="service-card-wrap">
                <MediaWrap
                  class="img-wrap"
                  :url="picPath"
                  :height="180"
                ></MediaWrap>
                <div class="infos-wrap">
                  <div class="title-wrap">
                    <div class="title">{{ instance.name }}</div>
                    <div class="icon-wrap">
                      <span class="iconItem">
                        <a-icon type="eye" :style="{ color: '#364759' }" />
                        <span>{{ instance.browseNum }}</span>
                      </span>
                    </div>
                  </div>
                  <span class="line"></span>
                  <a-row>
                    <a-col :span="8">
                      <span
                        >服务类型:{{ instance.thirdServiceTypeStr }}</span
                      ></a-col
                    >
                    <a-col :span="8">
                      <span>服务区域:{{ instance.area }}</span></a-col
                    >
                    <a-col :span="8"
                      ><span>发布日期:{{ instance.publishTime }}</span></a-col
                    >
                  </a-row>
                  <div class="description-wrap">
                    <span> 服务简介:{{ instance.summary }} </span>
                  </div>
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <SideWrap iconName="iconPhone.png" type="img" title="联系方式">
                <template>
                  <div class="side-body-wrap">
                    <div class="user-head">
                      <img src="/static/iconAvator.png" alt="" />
                    </div>
                    <div>联系人: {{ user.userName }}</div>
                    <div>电话: {{ user.phoneNumber }}</div>
                    <div>邮箱: {{ user.email }}</div>
                  </div>
                </template>
              </SideWrap>
            </a-col>
          </a-row>
        </div>
      </template>
    </DetailPageWrap>
  </div>
</template>

<script>
import DetailPageWrap from '@/components/common/DetailPageWrap'
// import SeriviceCard from '../components/SeriviceCard.vue'
import SideWrap from '../../MTradingMarket/components/SideWrap.vue'
import { titleCardOptions } from './detailData'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { receDetailServerInfo } from '@/api/serverInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      resultDetails: [],
      titleCardOptions,
      instance: {},
      picPath: '',
      user: {}
    }
  },
  components: {
    DetailPageWrap,
    SideWrap
  },
  mounted() {
    this.initRequest()
  },
  methods: {
    async initRequest() {
      const { id } = this.$route.query
      const { data } = await receDetailServerInfo(id)
      const datas = [data]
      const row = this.handlerDateFormat(datas)
      this.handlerResultMappings(row) // 处理数据的映射关系
      this.instance = row[0]
      let url = this.instance.fileVo
      if (url.length > 0) {
        this.picPath = url[0].filePath
      }
      this.user = this.instance.user
      this.resultDetails = [{ contents: [this.instance.detail] }]
    },
    handleChange(id) {
      if (id === 'example') {
        this.resultDetails = [{ contents: [this.instance.case] }]
        return
      }
      this.resultDetails = [{ contents: [this.instance.detail] }]
    }
  }
}
</script>
